import React from "react";

const Footer = ({ dim }) => (
  <footer
    style={{
      opacity: dim ? 0.3 : 1,
      transition: "opacity 0.3s ease",
      position: "sticky",
      bottom: 0,
      width: "100%",
      background: "#fff",
      color: "#555",
      textAlign: "center",
      padding: "0.8rem 0",
    }}
  >
    © 2025 secretsanta.gg
  </footer>
);


export default Footer;
